import React from 'react';

const formatCLP = (price) => {
    const numericPrice = Number(price) || 0;
    return numericPrice.toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 });
}

function Item({ item, agregarAlCarro, onPersonalizarItem, carro }) {
    // 🚩 VALIDACIÓN REAL: grupos deben tener opciones, no basta con que existan
    // 🚩 CORREGIDO: tiene_variantes SOLO es válido si los grupos realmente tienen opciones
    const gruposConOpciones = item.grupos && item.grupos.length > 0 && item.grupos.some(g => g && g.opciones && Array.isArray(g.opciones) && g.opciones.length > 0);
    const variantesConOpciones = item.variantes && item.variantes.length > 0 && item.variantes.some(g => g && g.opciones && Array.isArray(g.opciones) && g.opciones.length > 0);
    const tieneOpciones = gruposConOpciones || variantesConOpciones;

    // 🚩 CALCULAR CANTIDAD EN EL CARRO (sumando variantes del mismo producto)
    const cantidadEnCarro = (carro || []).reduce((total, i) => {
        const idItem = String(item.id);
        const idCarro = String(i.id).split('_')[0]; // Para productos con variantes tipo "123_162334..."
        if (idCarro === idItem || idCarro === `granel_${idItem}`) {
            return total + Number(i.cantidad || 0);
        }
        // También verificar por producto_id para productos a granel
        if (String(i.producto_id) === idItem) {
            return total + Number(i.cantidad || 0);
        }
        return total;
    }, 0);

    const handleAction = () => {
        if (tieneOpciones && onPersonalizarItem) {
            onPersonalizarItem(item);
        } else {
            agregarAlCarro(item);
        }
    };

    const imageUrl = item.url_imagen || 'https://via.placeholder.com/150';

    return (
        <>
            {/* ESTILOS INYECTADOS DIRECTAMENTE */}
            <style>{`
                .pos-item-card {
                    background: white;
                    border-radius: 12px;
                    overflow: hidden;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #e0e0e0;
                    transition: all 0.1s ease-in-out;
                    cursor: pointer;
                    user-select: none;
                    height: 100%;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
                }

                /* Efecto de presión al tocar (Feedback háptico visual) */
                .pos-item-card:active {
                    transform: scale(0.95);
                    background-color: #f0f0f0;
                    box-shadow: none;
                }

                .pos-price-badge {
                    position: absolute;
                    top: 6px;
                    left: 6px;
                    background: rgba(40, 167, 69, 0.9);
                    color: white;
                    padding: 2px 8px;
                    border-radius: 6px;
                    font-weight: 800;
                    font-size: 0.8rem;
                    z-index: 10;
                    backdrop-filter: blur(4px);
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                }

                .pos-qty-badge {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    background: #dc3545;
                    color: white;
                    min-width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    font-weight: 900;
                    font-size: 0.75rem;
                    z-index: 10;
                    box-shadow: 0 2px 6px rgba(220, 53, 69, 0.4);
                    border: 2px solid white;
                    padding: 0 2px;
                }

                .pos-image-container {
                    width: 100%;
                    aspect-ratio: 1 / 1; /* Cuadrado perfecto siempre */
                    overflow: hidden;
                    background-color: #f8f9fa;
                }

                .pos-image-container img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover; /* La imagen llena el espacio sin deformarse */
                }

                .pos-content {
                    padding: 8px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    flex-grow: 1;
                    min-height: 55px;
                }

                .pos-name {
                    font-size: 0.85rem;
                    font-weight: 700;
                    color: #2d3436;
                    line-height: 1.2;
                    margin: 0;
                    display: -webkit-box;
                    -webkit-line-clamp: 2; /* Máximo 2 líneas de texto */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .pos-option-tag {
                    font-size: 0.65rem;
                    color: #17a2b8;
                    font-weight: 800;
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    text-transform: uppercase;
                }

                /* OPTIMIZACIÓN PARA SMARTPHONES (2 COLUMNAS) */
                @media (max-width: 767px) {
                    .pos-name {
                        font-size: 0.75rem;
                    }
                    .pos-price-badge {
                        font-size: 0.7rem;
                        padding: 1px 6px;
                    }
                }
            `}</style>

            <div className="pos-item-card" onClick={handleAction}>
                {/* PRECIO */}
                <div className="pos-price-badge">
                    {formatCLP(item.valor || item.precio)}
                </div>

                {/* CANTIDAD EN EL CARRO (solo si > 0) */}
                {cantidadEnCarro > 0 && (
                    <div className="pos-qty-badge">
                        {cantidadEnCarro}
                    </div>
                )}

                {/* IMAGEN */}
                <div className="pos-image-container">
                    <img src={imageUrl} alt={item.nombre} loading="lazy" />
                </div>

                {/* INFO PRODUCTO */}
                <div className="pos-content">
                    <p className="pos-name">{item.nombre}</p>
                    
                    {tieneOpciones && (
                        <div className="pos-option-tag">
                            <i className="fas fa-plus-circle mr-1"></i> Personalizable
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export { Item };